export class MenuItem {
  title: string;
  subtitle: string;
  url: string;
  icon: string;
  num: number;
  showNumber: boolean;
}

